'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GRADIENT_ID = 'dibs-spinner-gradient';

var renderGradient = function renderGradient(gradientId, solidClass, transparentClass) {
    return _react2.default.createElement(
        'linearGradient',
        { id: gradientId, x1: '1', y1: '0', x2: '0', y2: '1', gradientUnits: 'objectBoundingBox' },
        _react2.default.createElement('stop', { offset: '40%', className: transparentClass }),
        _react2.default.createElement('stop', { offset: '85%', className: solidClass }),
        _react2.default.createElement('stop', { offset: '100%', className: solidClass })
    );
};

var Spinner = function Spinner(props) {
    var _classNames, _classNames2;

    var theme = props.theme,
        _props$dark = props.dark,
        dark = _props$dark === undefined ? false : _props$dark,
        _props$containerClass = props.containerClass,
        containerClass = _props$containerClass === undefined ? '' : _props$containerClass,
        _props$size = props.size,
        size = _props$size === undefined ? 'small' : _props$size;


    if (!theme) {
        return null;
    }

    var solid = dark ? theme.colorDarkSolid : theme.colorLightSolid;
    var transparent = dark ? theme.colorDarkTransparent : theme.colorLightTransparent;
    var shadow = (0, _classnames2.default)(theme.shadow, (_classNames = {}, (0, _defineProperty3.default)(_classNames, theme.colorDarkShadow, dark), (0, _defineProperty3.default)(_classNames, theme.colorLightShadow, !dark), _classNames));
    var container = (0, _classnames2.default)(containerClass, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, theme.small, size === 'small'), (0, _defineProperty3.default)(_classNames2, theme.tiny, size === 'tiny'), _classNames2));

    return _react2.default.createElement(
        'div',
        { className: container },
        _react2.default.createElement(
            'svg',
            { className: theme.spinner, viewBox: '0 0 250 250' },
            _react2.default.createElement(
                'defs',
                null,
                renderGradient(GRADIENT_ID, solid, transparent)
            ),
            _react2.default.createElement('circle', {
                className: shadow,
                cx: 125,
                cy: 125,
                r: 106
            }),
            _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement('path', { fill: 'url(#' + GRADIENT_ID + ')', d: 'M125,250 C194.035937,250 250,194.035937 250,125 L212.5,125 C212.5,173.246875 173.248437,212.5 125,212.5' }),
                _react2.default.createElement('path', { className: solid, d: 'M125.217391,212.5 C76.8850435,212.5 37.5652174,173.246875 37.5652174,125 C37.5652174,76.753125 76.8850435,37.5 125.217391,37.5 C135.590087,37.5 144,29.1046875 144,18.75 C144,8.3953125 135.590087,0 125.217391,0 C56.0613913,0 0,55.9640625 0,125 C0,194.035937 56.0613913,250 125.217391,250' })
            )
        )
    );
};

exports.default = Spinner;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/lib/Spinner/index.js
// module id = ./node_modules/dibs-elements/lib/Spinner/index.js
// module chunks = 4